import React from 'react';

import { FraudReviewStatistic } from './components';
import { useFraudReviewStatisticLogic, useGetFraudReviewURL } from './hooks';
import { useGetFraudReviewStatisticQuery } from './queries';

const FraudReviewStatisticContainer: React.FC = () => {
  const { isLoading, isEmpty, data } = useGetFraudReviewStatisticQuery();
  const { count, isDetailsLinkVisible, isHidden } = useFraudReviewStatisticLogic({ data });
  const currentURL = useGetFraudReviewURL();

  if (isHidden || isEmpty) {
    return null;
  }

  return (
    <FraudReviewStatistic
      isLoading={isLoading}
      url={currentURL}
      count={count}
      isDetailsLinkVisible={isDetailsLinkVisible}
    />
  );
};

export default FraudReviewStatisticContainer;
